import React from "react";
import {List, ListItem, ListItemButton, ListItemIcon, ListItemText, Checkbox, Radio, Paper} from "@mui/material";
import {s_app_sl} from "../_signals/s_app";
import {s_chars} from "../_signals/s_chars";
import {IChar} from "../_interfaces/IChar";

interface TargetSelectionProps {
    vstarget: string;
    targets: string[];
    setTargets: (targets: string[]) => void;
    setTargetOpen: (open: boolean) => void;
}

const rollerTargetSelection: React.FC<TargetSelectionProps> = ({ vstarget, targets, setTargets, setTargetOpen }) => {
    const available = (char: IChar) => {
        return s_app_sl.value || !char.nsc || (char.nsc && char.visible);
    };

    const handleSingleTarget = (id: string) => {
        const newTargets = targets.includes(id) ? [] : [id];
        setTargets(newTargets);
    };

    const handleMultipleTarget = (id: string) => {
        const newTargets = [...targets];
        const currentIndex = newTargets.indexOf(id);
        if (currentIndex === -1) {
            newTargets.push(id);
        } else {
            newTargets.splice(currentIndex, 1);
        }
        setTargets(newTargets);
    };

    const renderList = (isSingle: boolean) => (
        <List dense sx={{width: '100%', bgcolor: 'background.paper'}}>
    {Array.from(s_chars.value.values()).map((char) => {
        if (!available(char)) return null;
        const labelId = `checkbox-list-label-${char.id}`;
        return (
            <ListItem key={'liid' + char.id} style={{width: "100%"}}>
        <ListItemButton role={undefined} onClick={() => isSingle ? handleSingleTarget(char.id) : handleMultipleTarget(char.id)} dense>
        <ListItemIcon>
            {isSingle ? (
                    <Radio checked={targets.includes(char.id)} />
    ) : (
            <Checkbox checked={targets.includes(char.id)} tabIndex={-1} disableRipple inputProps={{'aria-labelledby': labelId}} />
    )}
        </ListItemIcon>
        <ListItemText id={labelId} primary={char.name}/>
        </ListItemButton>
        </ListItem>
    );
    })}
    </List>
);

    return (
        <Paper style={{padding: '20px 24px', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, zIndex: 100}}>
    {vstarget === 'z' ? renderList(true) : null}
    {['e', 'g', 'g+'].includes(vstarget) ? renderList(false) : null}
    </Paper>
);
};

export default rollerTargetSelection;